import { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  getPriceForCountry,
  getSelectedCountry,
} from "../../functions/CountryFunctions";

import "./AlsoBought.css";

const AlsoBought = ({ productid, collection }) => {
  const [showMore, setShowMore] = useState(false);

  const allProducts = useSelector((state) => state.store.store) || [];
  const selectedCountry = getSelectedCountry();

  const currentProduct = allProducts.find(
    (product) => product.id === productid,
  );

  const manualProducts =
    currentProduct?.completeTheLook
      ?.map((id) => allProducts.find((product) => product.id === id))
      .filter(Boolean) || [];

  const fallbackProducts = allProducts
    .filter((product) => product.id !== productid)
    .filter((product) => product.collection === collection)
    .filter((product) => product.variants?.[0]?.imageURLs?.[0])
    .reverse();

  const products = (
    manualProducts.length ? manualProducts : fallbackProducts
  ).slice(0, 8);

  const visibleProducts = showMore ? products : products.slice(0, 4);

  if (!products.length) return null;

  return (
    <section className="also-bought content-padding">
      <div className="also-bought-header">
        <h1>Complete The Look</h1>
        <p>Customers also bought</p>
      </div>

      <div className="also-bought-grid">
        {visibleProducts.map((product) => {
          const { price, symbol } = getPriceForCountry(
            product.prices,
            selectedCountry,
          );

          const imageUrl = product.variants?.[0]?.imageURLs?.[0];

          return (
            <Link
              to={`/shop/${product.id}`}
              key={product.id}
              className="also-bought-card"
            >
              <div className="also-bought-image">
                <img src={imageUrl} alt={product.title} loading="lazy" />
              </div>

              <div className="also-bought-info">
                <p className="also-bought-title">{product.title}</p>

                {product.tagline && (
                  <p className="also-bought-tagline">{product.tagline}</p>
                )}

                <p className="also-bought-price">
                  {symbol}
                  {price}
                </p>
              </div>
            </Link>
          );
        })}
      </div>

      {products.length > 4 && (
        <div className="also-bought-more">
          <button
            type="button"
            className="btn-outline-primary btn btn-round flex-center"
            onClick={() => setShowMore((prev) => !prev)}
          >
            {showMore ? "Show Less" : "View More"}
          </button>
        </div>
      )}
    </section>
  );
};

export default AlsoBought;
